import { Container, Row, Col } from "react-bootstrap"

const Footer = () => {
  return (
    <footer className="no-gutters" style={{ position: 'relative' }}>
      <Container>
        <Row className="align-items-center justify-content-center">
          {/* Left - Contact Details */}
          <Col lg={4} md={12} sm={12} className="text-center mb-4 mb-lg-0">
            <div className="footer-contact wow fadeInLeft" data-wow-delay="100ms" style={{ marginTop: '-50px' }}>
              <h5 style={{ color: '#fff', marginBottom: '20px', fontWeight: '700', fontSize: '1.3rem', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.6)' }}>Contact Us</h5>
              <p style={{ marginBottom: '12px', fontSize: '1.1rem' }}>
                <i className="fas fa-phone" style={{ color: '#FFD700', marginRight: '10px' }}></i>
                <a href="tel:+919740599994" style={{ color: '#fff', textDecoration: 'none', textShadow: '1px 1px 3px rgba(0, 0, 0, 0.6)' }}>+91 9740599994</a>
              </p>
              <p style={{ marginBottom: '0', fontSize: '1.1rem' }}>
                <i className="fab fa-whatsapp" style={{ color: '#25D366', marginRight: '10px' }}></i>
                <a href="https://wa.me/919740599994" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', textDecoration: 'none', textShadow: '1px 1px 3px rgba(0, 0, 0, 0.6)' }}>+91 9740599994</a>
              </p>
            </div>
          </Col>
          
          {/* Right - Gayatri Mantra (Large, White, 2 lines) */}
          <Col lg={8} md={12} sm={12} className="text-center mb-4 mb-lg-0">
            <div className="footer-mantra wow fadeInRight" data-wow-delay="200ms">
              <div className="gayatri-mantra">
                <p style={{ marginBottom: '15px' }}>ॐ भूर्भुवः स्वः । तत्सवितुर्वरेण्यं ।</p>
                <p style={{ marginBottom: '0' }}>भर्गो देवस्य धीमहि । धियो यो नः प्रचोदयात् ॥</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      
      {/* Copyright - Absolute Bottom (Outside Container) */}
      <div style={{
        position: 'absolute',
        bottom: '10px',
        left: 0,
        right: 0,
        zIndex: 3
      }}>
        <p className="text-center wow fadeInUp" data-wow-delay="400ms" style={{ marginBottom: '0', color: '#fff', textShadow: '1px 1px 3px rgba(0, 0, 0, 0.6)' }}>
          © {(new Date).getFullYear()} Pandit Nilesh Pandey. All rights reserved. Developed by <a href="https://imedhya.com" target="_blank" rel="noopener noreferrer" style={{ color: '#FFD700', textDecoration: 'none' }}>Medhya Digital</a>
        </p>
      </div>
    </footer>
  )
}

export default Footer